//@ts-nocheck
import clsx from 'clsx';
import styles from './cta-btn.module.css';
import { GoDotFill } from "react-icons/go";
import { HiArrowRight } from "react-icons/hi2";
import Link from 'next/link';

function CTABtn({
    btnName = "Click here",
    btnURL = "#",
    colorMode = "light-mode",
    newTab = false,
    passedFunction,
}: CTABtnProps) {
    const target = newTab ? "_blank" : undefined;

    return (
        <Link href={btnURL} legacyBehavior>
            <a
                rel="noopener noreferrer"
                className={clsx(styles["cta-btn-wrapper"], styles[colorMode])}
                style={{ textDecoration: "none" }}
                target={target}
                onClick={(e) => {
                    if (passedFunction) {
                        passedFunction(e);
                    }
                }}
            >
                <div className={styles["btn-wrapper"]}>
                    {btnName}
                    <div className={styles["right-icon"]}>
                        <GoDotFill color={"white"} size={15} />
                    </div>
                </div>
                <div className={styles["btn-wrapper-hover"]}>
                    {btnName}
                    <div className={clsx(styles["right-icon"], "hover")}>
                        <HiArrowRight fontSize={18} color="white" />
                    </div>
                </div>
            </a>
        </Link>
    );
}

export default CTABtn;